import React, { useState, useEffect } from "react";
import {
  Avatar,
  Grow,
  Paper,
  ClickAwayListener,
  Menu,
  MenuItem,
  Popper,
  Tooltip,
  Grid,
  Typography,
  Hidden,
  DialogActions,Button
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Close from "@material-ui/icons/Close";
import Link from '@material-ui/core/Link'
import { withStyles, makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../../../helpers";
import { routePaths } from "../../../config/route-paths";
import { updateSelectedVal } from "./model/profile-action";
import { commonService } from "../../../../services/common.service";
import { useMediaQuery } from "react-responsive";
import "../../../common/common.css";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import i18next from "i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import Cookies from "universal-cookie";

const StyleAvatar = withStyles((theme) => ({
  root: {
    background: theme.palette.ePrimary?.base,
  },
}))(Avatar);

const useStyles = makeStyles((theme) => ({
  blueText: {
    color: theme.palette.ePrimary?.base,
    cursor: "pointer",
  },
  blueBox: {
    backgroundColor: theme.palette.ePrimary?.base,
    borderRadius: "4px",
    justifyContent: "flex-start",
    color: theme.palette.eWhite?.base,
    cursor: "pointer",
  },
  customerNameMenuItem: {
    "&:hover": {
      backgroundColor: theme.palette.ePrimary?.base,
      borderRadius: "0.25rem",
      border: "0.063rem solid " + theme.palette.ePrimary?.base + " !important",
      justifyContent: "flex-start",
      color: theme.palette.eWhite?.base,
    },
    "&:focus": {
      backgroundColor: theme.palette.ePrimary?.base,
      borderRadius: "0.25rem",
      border: "0.063rem solid " + theme.palette.ePrimary?.base + " !important",
      justifyContent: "flex-start",
      color: theme.palette.eWhite?.base,
    },
  },
  styleIndex: {
    zIndex: "1",
  },
  maxwidthName: {
    maxWidth: "15rem !important",
  },dialogContainerStyling: {
    "& .MuiDialog-paperWidthSm": {
        [theme.breakpoints.up("sm")]: {
            minWidth: "25rem !important"
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "20rem !important"
        },
    }
}, contentColor: {
  background: theme.palette.ePrimary.base,
  color: theme.palette.eWhite.base,
  paddingLeft: "5%",
},
rightIcon: {
  textAlign: "-webkit-right",
}, closeIcon: {
  color: theme.palette.eWhite.base,
},
button:{
"&.MuiIconButton-root":{
  padding:"8px !important"
}
},
divdersss:{
  "&.MuiDialogContent-dividers":{
    padding:"12px 22px !important"
  }
},
alertIcon: {
  color: theme?.palette?.eTertiary?.base,
  width: "4rem",
  height: "auto",
  display: "block",
  justifyContent: "center",
  // margin: "1rem auto",
},
dialogTextPadding: {
  // padding: "0rem 1.875rem 1.875rem",
  textAlign: "center"
},
no: {
  color: theme.palette.ePrimary.base,
},
yes: {
  backgroundColor: theme.palette.ePrimary.base,
  color: theme.palette.eWhite.base,
  borderRadius: 30,
  "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
  },
  padding: "3% 20%",
}, circularProgressColor: {
color: theme.palette.ePrimary.base,
},
}));

export default function E_ProfileDropdown({ profileData }) {
  let [open, setOpen] = useState(false);
  let dispatch = useDispatch();
  const cookies = new Cookies();
  const anchorRef = React.useRef(null);
  let profileDetails = useSelector((store) => store?.profileDetails);
  let notification = useSelector((store) => store?.notificationDot?.data);
  const {t:labels, ready: labelReady}=useTranslation("label-E_HEADER");
  let [manageProfile, setManageProfile] = useState(false);
  let [managePreference, setManagePreference] = useState(false);
  let [linkedAccount, setLinkedAccount] = useState(false);
  let [getHelp, setGetHelp] = useState(false);
  const [openDialog,setopenDialog]=useState(false)
  const [name,setName] = useState()
  let isTabletOrMobile = useMediaQuery({ minWidth: 961 });
  const bearer = JSON.parse(localStorage.getItem("bearer"));
  const accountSelected = localStorage.getItem("accountSelected")
  const logoutPopUp= localStorage.getItem("enabled_state")
  let selectedAcc = localStorage.getItem('accountSelected')
  useEffect(() => {
    profileData.map((item) => {
      item.widgetCode === "E_HEADER.MANAGE_PROFILE" && setManageProfile(true);
      item.widgetCode === "E_HEADER.MANAGE_PREFERENCE" &&
        setManagePreference(true);
      item.widgetCode === "E_HEADER.LINKED_ACCOUNT" && setLinkedAccount(true);
      item.widgetCode === "E_HEADER.GET_HELP" && setGetHelp(true);
    });
  }, profileData);

  let classes = useStyles();
  const handleCloseAway = () => {
    setOpen(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleProfileClick = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    history.push(routePaths.PROFILE);
    dispatch(updateSelectedVal(event.target.value));
  };

  const handleManagePreference = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.push(routePaths.MANAGE_PREFERENCE);
    dispatch(updateSelectedVal(event.target.value));
    setOpen(false);
  };

  let handleLinkedAccount = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.push(routePaths.PROFILE);
    dispatch(updateSelectedVal(event.target.value));
    setOpen(false);
  };
  let handlehelp = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.push(routePaths.SELF_HELP);
    setOpen(false);
  };
  const handleCloseDilog=()=>{
    setopenDialog(false);
  }
  const dialog = (e)=>{
    setopenDialog(true)
  }
  const logout = (event) => {
    setOpen(false);
    let unreadMeter = localStorage.getItem("unreadMeter");
    let unreadBill = localStorage.getItem("unreadBill");
    let unreadAnnouncement = localStorage.getItem("unreadAnnouncement");
    localStorage.setItem("i18nextLng","en")
    cookies.set("i18next","en")
    unreadMeter = JSON.parse(unreadMeter);
    unreadBill = JSON.parse(unreadBill);
    unreadAnnouncement = JSON.parse(unreadAnnouncement);

    if (
      unreadBill?.length > 0 ||
      unreadMeter?.length > 0 ||
      unreadAnnouncement?.length > 0 ||
      notification?.Meter === true ||
      notification?.Bill === true ||
      notification?.Outage === true ||
      notification?.Announcements === true
    ) {
      let ok = window.confirm(labels?.E_NOTIFICATION_LOGOUT_WARNING);
      if (ok === true) {
        i18next.changeLanguage("en");
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
          return;
        }
        commonService.logoutUser();
      }
      // window.addEventListener("beforeunload", (event) => {
      //   event.returnValue = "labels.E_NOTIFICATION_LOGOUT_WARNING";
      // });
    } else {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
      commonService.logoutUser();
    }
  };

  useEffect(()=>{
    let fetchPersonId=bearer?.accountDetails.accountSummary.personAcccountDetail.personAccountList
    let filteredId;
    if(Array.isArray(bearer?.accountDetails?.accountSummary?.personDetailList)){
        let personId=bearer?.personId
        let loggedInUserName;
        if(bearer?.isTenant=='Y'){
          if(Array.isArray(fetchPersonId)){
            filteredId  = bearer?.accountDetails.accountSummary.personAcccountDetail.personAccountList?.find(e=>e?.customerNumber==selectedAcc)
            bearer.personId=filteredId?.personId
            localStorage.setItem("bearer",JSON.stringify(bearer))

          }
          loggedInUserName = bearer?.accountDetails?.accountSummary?.personDetailList?.filter((e)=>{
            if(e["C1-Person"]?.personId==filteredId?.personId){
              return e
            }
          })
        }else{
          loggedInUserName = bearer?.accountDetails?.accountSummary?.personDetailList?.filter((e)=>{
            if(e["C1-Person"]?.personId==personId){
              return e
            }
          })
        }
        
        setName(loggedInUserName[0]["C1-Person"].personName.entityName)
    }else{
      setName(bearer?.accountDetails?.accountSummary?.personDetailList["C1-Person"]?.personName?.entityName)
    }
  },[selectedAcc])
  return (
    <>
      <div ref={anchorRef} onClick={handleToggle}>
        {profileDetails && (
          <Grid
            container
            spacing={1}
            alignItems="center"
            className={
              open && isTabletOrMobile ? classes.blueBox : classes.blueText
            }
          >
            <Grid item>
              {" "}
              <StyleAvatar />
            </Grid>
            <Hidden mdDown>
              <Grid item className={classes.maxwidthName}>
                <Typography variant="subtitle2" className="wrapin3line">
                {name}
                  <KeyboardArrowDownIcon />
                </Typography>
              </Grid>
            </Hidden>
          </Grid>
        )}
      </div>
      <Menu
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleCloseAway}
        autoFocusItem={open}
        id="menu-list-grow"
        onKeyDown={handleListKeyDown}
        className={classes.blueText}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}

      >
        <Hidden mdUp>
          {profileDetails && (
            <MenuItem
              className={classes.blueBox}
              classes={{ root: classes.customerNameMenuItem }}
              id="profile-details-firstname"
              onClick={handleCloseAway}
            >
              <b>
              {name}

              </b>
            </MenuItem>
          )}
        </Hidden>

        {manageProfile && (
          <MenuItem
            className={`profile-menu-item ${classes.blueText}`}
            id="profile-menu-option-details"
            value={0}
            onClick={handleProfileClick}
          >
            {labelReady ? labels("E_HEADER_MANAGE_PROFILE"): <Skeleton />}
          </MenuItem>
        )}
        {managePreference && (
          <MenuItem
            className={`profile-menu-item ${classes.blueText}`}
            id="profile-menu-option-manage-preferences"
            value={1}
            onClick={handleManagePreference}
          >
            {labelReady ? labels("E_HEADER_MANAGE_PREFERENCE"): <Skeleton />}
          </MenuItem>
        )}
        {linkedAccount && (
          <MenuItem
            className={`profile-menu-item ${classes.blueText}`}
            id="profile-menu-option-password"
            value={2}
            onClick={handleLinkedAccount}
          >
            {labelReady ? labels("E_HEADER_LINKED_ACCOUNTS"): <Skeleton />}
          </MenuItem>
        )}
        {getHelp && (
          <MenuItem
            className={`profile-menu-item ${classes.blueText}`}
            id="profile-menu-option-preferences"
            onClick={handlehelp}
          >
            {labelReady ? labels("E_HEADER_GET_HELP"): <Skeleton />}
          </MenuItem>
        )}
        <MenuItem
          className={`profile-menu-item ${classes.blueText}`}
          id="profile-menu-option-logout"
          onClick={logoutPopUp == 1 ? dialog : logout}
        >
          {labelReady ? labels("E_HEADER_LOGOUT"): <Skeleton />}
        </MenuItem>
      </Menu>
      {openDialog?  <Dialog onClose={handleCloseDilog} open={openDialog} className={classes.dialogContainerStyling}>
                    <Grid
                        container
                        alignItems="center"
                        className={classes.contentColor}
                        justify="space-between"
                    >
                        <Grid item xs={10}>
                                <Typography variant="subtitle2">{labelReady ? labels("E_HEADER_CON") : <Skeleton />}</Typography>
                        </Grid>
                        <Grid item xs={2} className={classes.rightIcon}>
                            <IconButton aria-label="close" className={classes.button} onClick={handleCloseDilog}>
                                <Close className={classes.closeIcon} />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <DialogContent className={classes.divdersss} dividers>
                      <Grid align="center">
                      <WarningRoundedIcon className={classes.alertIcon} />
                      </Grid>
                   <Typography>{labelReady ? labels("E_HEADER_LOGOUT_MSG") : <Skeleton />}</Typography>
                    </DialogContent>
                    <DialogActions className={classes.dialoagActionPadding}>
                        <Grid item xs={1} sm={1}>
                            <Link component="button" onClick={handleCloseDilog} underline="hover" className={classes.no}>
                                    <Typography variant="button" >{labelReady ? labels("E_HEADER_CANCLE") : <Skeleton />}</Typography>
                            </Link>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={classes.yes}
                                size="small"
                                align="right"
                                onClick={logout}
                            >
                                    <Typography variant="button">{labelReady ? labels("E_HEADER_LOGOUT_POP") : <Skeleton />}</Typography>
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>:null}
    </>
  );
}
